import React from 'react';
import { StateValue } from 'xstate';
import classNames from 'classnames'
import GameButton from '../GameButton';
import { FarkleLogic } from '../../game/FarkleLogic';
import { gameContext } from '../../game/Farkle';
import { useHistory } from 'react-router-dom';

type GameButtonProps = {
  turnState: StateValue,
  sendGameEvent: Function,
  context: gameContext,
  isPlayersTurn: boolean,
  isGameOver: boolean
  endGame?():any,
}

const GameControls = ({ turnState, sendGameEvent, context, isPlayersTurn, isGameOver, endGame}: GameButtonProps) => {
  const allFrozenDice = FarkleLogic.mergeBoolean(context.frozen, context.frozenThisRoll)
  const frozenDiceVals = FarkleLogic.getFrozen(context.dice, allFrozenDice)
  const canEndTurn = FarkleLogic.canEndTurn(frozenDiceVals, context.scores[context.player], context.scoreThisRoll)
  const canClickEndTurn = canEndTurn || turnState === 'farkle'

  const history = useHistory()

  const newPlayers = () => {
    if (endGame) endGame()
    history.push('/')
  }
  
  return (
    <div className={classNames("game-buttons", { 'highlighted': turnState === 'start'})} >
      {(isPlayersTurn && (turnState === 'ready' || turnState === 'observing' || turnState === 'start')) && (
        <GameButton 
          id="roll-button"
          onClick={() => sendGameEvent('ROLL')} 
          isDisabled={turnState === 'observing' && !FarkleLogic.canRoll(frozenDiceVals, context.frozenThisRoll)}
          disabledTooltip={`Invalid move`}
        >Roll</GameButton>
      )}
      {(isPlayersTurn && (turnState === 'ready' || turnState === 'observing' || turnState === 'farkle' )) && (
        <GameButton 
          id="end-turn-button"
          onClick={() => sendGameEvent('END_TURN')} 
          isDisabled={!canClickEndTurn}
          disabledTooltip={`Can't end turn`}
        >End Turn</GameButton>
      )}
      { isGameOver && (
        <>
          <GameButton 
            id="return-home-button"
            onClick={() => newPlayers()} // TODO
          >Play again</GameButton>
        </>
      )}
    </div>
  );
};


export default GameControls;
